module.exports = __webpack_public_path__ + "media/images/gateway/bitpay-1-8058e45516fc86f7c2044ac23b3d275b.png";